module.exports = __webpack_public_path__ + "img/manageUsers.600ae7d0.svg";